import {controlRangeInput} from "../../sources/js/functions/form-control";


(function(){
    const input_range = document.getElementById('inputRangeSum');
    const input = document.getElementById('inputSum');
    const btn_search = document.getElementById('offerSearch');
    const offerTerm = document.getElementById('offerTerm');
    const offers_content = document.getElementById('offersContent');

    controlRangeInput(input_range, input);


    if(input_range && input) {

        /*=== Filter ===*/

        if (btn_search && offers_content) {
            btn_search.addEventListener('click', function () {
                let sum_min = +input_range.min;
                let current_sum_max = input.value.replace(/\s+/g, '');
                    current_sum_max = current_sum_max.length > 0 ? current_sum_max : sum_min;
                let page_type = this.getAttribute('data-page-type');

                let formData = new FormData();

                formData.append('action', 'get_offer_filter');
                formData.append('current_sum_max', current_sum_max);
                formData.append('page_type', page_type);
                formData.append('more_text', btn_search.getAttribute('data-more-text'));

                if (offerTerm) {
                    let current_term = offerTerm.getAttribute('data-term');
                    formData.append('current_term', current_term);
                }

                fetch(settings.ajax_url, {method: 'POST', body: formData})
                    .then(function (response) { return response.text(); })
                    .then(function (data) {

                        offers_content.innerHTML = data;

                        if (document.getElementById('offerMore') && document.getElementById('offersData')) {
                            let btn_more = document.getElementById('offerMore');
                            let new_more = document.getElementById('offersData')
                            btn_more.setAttribute('data-pages', new_more.getAttribute('data-filter-page'));
                            btn_more.setAttribute('data-offset', new_more.getAttribute('data-filter-offset'));
                            btn_more.setAttribute('data-current-page', '1');

                            if (new_more.getAttribute('data-filter-page') == 1) {
                                btn_more.closest('.offers__more').classList.add('offers__more_hidden');
                            } else {
                                btn_more.closest('.offers__more').classList.remove('offers__more_hidden');
                            }
                        }
                    })
                    .catch(function (err) { console.log(err); });
            });
        }


        /*=== Show More ===*/

        document.addEventListener('click', function (e) {

            if (e.target.id === 'offerMore') {
                let offersData = document.getElementById('offersData');
                let btn_more = document.getElementById('offerMore');

                let sum_min = +input_range.min;
                let current_sum_max = input.value.replace(/\s+/g, '');
                    current_sum_max = current_sum_max.length > 0 ? current_sum_max : sum_min;
                let pages = btn_more.getAttribute('data-pages');
                let current_page = btn_more.getAttribute('data-current-page');
                let offset = btn_more.getAttribute('data-offset');
                let current_offset = current_page * offset;
                let page_type = btn_more.getAttribute('data-page-type');
                let formData = new FormData();


                formData.append('action', 'get_offer_more');
                formData.append('current_sum_max', current_sum_max);
                formData.append('current_offset', current_offset);
                formData.append('page_type', page_type);
                formData.append('default', btn_more.getAttribute('data-default-meta'));
                if (offerTerm) {
                    let current_term = offerTerm.getAttribute('data-term');
                    formData.append('current_term', current_term);
                }
                fetch(settings.ajax_url, {method: 'POST', body: formData})
                    .then(function (response) { return response.text(); })
                    .then(function (data) {
                        offersData.innerHTML += data;

                        current_page++;
                        btn_more.setAttribute('data-current-page', current_page);

                        if (current_page == pages) {
                            btn_more.closest('.offers__more').classList.add('offers__more_hidden');
                        }
                    })
                    .catch(function (err) { console.log(err); });
            }
        });
    }
})();
